export const environment = {
  production: true,
  //base_url:'http://localhost:8100',
  // base_url:'https://apisdev.policia.gob.ec/api/spr',
  // fileJarAndPath: 'spr-1.0-SNAPSHOT.jar',
  // templateJasperPath: 'spr',
  base_url:'https://apis.policia.gob.ec/api/spr',  
 fileJarAndPath: 'opt/report-adapters/spr-1.0-SNAPSHOT.jar',
  templateJasperPath: 'opt/report-templates/spr',
  // apiAuth: 'https://apisdev.policia.gob.ec/api/security/auth/v1/token',
  // apiUserSippne: 'https://apisdev.policia.gob.ec/api/siipne-integration/v1/personal/',
  // apiSiipneUnidades:'https://apisdev.policia.gob.ec/api/siipne-integration/v1/unidad-policial',
  // apiReport : 'https://apisdev.policia.gob.ec/api/reporting/v1/generar',
  apiAuth: 'https://apis.policia.gob.ec/api/security/auth/v1/token',
  apiUserSippne: 'https://apis.policia.gob.ec/api/siipne-integration/v1/personal/',
  apiSiipneUnidades:'https://apis.policia.gob.ec/api/siipne-integration/v1/unidad-policial',
  apiReport : 'https://apis.policia.gob.ec/api/reporting/v1/generar',

catalogosSprFront:{
  PERMISO_CREAR:  1,
  PERMISO_LEER:  2,
  PERMISO_ACTUALIZAR:  3,
  PERMISO_BORRAR:  4,

   /* CATÁLOGO DE ROLES */
   ROLES_ADMINISTRADOR:  1,
   ROLES_SUBADMINISTRADOR:  2,
   ROLES_LIDER_METODOLOGICO:  3,
   ROLES_ANALISTA_METODOLOGICO:  4,
   ROLES_TITULAR:  5,
   ROLES_LIDER_DE_PROYECTO:  6,
   ROLES_LIDER_DE_PLAN_DE_ACCION:  7,
   ROLES_OBSERVADOR:  8,
   ROLES_PATROCINADOR_EJECUTIVO:  9,
   ROLES_LIDER_DE_LINEA_DE_ACCION:  1,

   /* CATALOGO DE APLICACIONES */
    APP_ID_SPRAMBIENTE_CG_N1:  3,
    APP_AMBIENTES:  1,
    APP_USUARIOS:  2,
    APP_APLICACIONES:  3,
    APP_ROLES:  4,
    APP_PERMISOS:  5,
    APP_SUBSISTEMAS:  6,
    APP_ROLES_APLICACIONES:  7,
    APP_CATALOGO_ESPECIAL_UNO:  8,
    APP_CATALOGO_ESPECIAL_DOS:  9,
    APP_CATALOGO_COMUN:  10,
    APP_PLAN_INSTITUCIONAL:  11,
    APP_PLAN_ANIOS:  12,
    APP_ANIOS:  13,

  APP_AREAS: 14,
  APP_OBJETIVOS_ESTRATEGIAS: 15,
  APP_LINEAS_ACCION: 16,
  APP_PLANES_ACCION: 17,
  APP_PROYECTOS: 18,
  APP_PROCESOS: 19,
  APP_INDICADORES: 20,
  APP_RIESGOS: 21,
  APP_UMBRALES: 22,
  APP_VISION_MISION: 23, 
  APP_COMPETENCIAS_ATRIBUCIONES: 24,
  APP_PARTICIPANTES_ELEMENTOS: 25,//preguntar
  APP_EQUIPO_GERENCIAL: 25,
  APP_ELEMENTOS_NIVELES_PERMISOS: 26,
  APP_REPORTE_PLANES: 27,

  //##############################################################
 ID_COMUNES_TIPO_LINEA_PLAN_DE_ACCION :  16 ,// verificado-24
 ID_COMUNES_TIPO_PROYECTO:  25,// verificado-24
 ID_COMUNES_TIPO_CLIENTE:  33,// verificado-24
 ID_COMUNES_VIABILIDAD_TECNICA:  36,// verificado-24
 ID_COMUNES_CATEGORIA_HITO:  41,// verificado-24
 ID_COMUNES_MEJORAS:  51,// verificado-24
 ID_COMUNES_CARACTERISTICA_PROCESO:  56,// verificado-24
 ID_COMUNES_FRECUENCIA:  65,// verificado-24
 ID_COMUNES_COMPORTAMIENTO:  71,// verificado-24
 ID_COMUNES_EXPRESION_INDICADOR:  74,// verificado-24
 ID_COMUNES_ESTRUCTUTA_DESGLOSE:  77,// verificado-24
 ID_COMUNES_TIPO_ACCION:  81,// verificado-24
 ID_COMUNES_NIVELES:  2,
 ID_COMUNES_NIVEL_1:  3,
 ID_COMUNES_NIVEL_5:  7,


  /**PARTICIPANTES DE LOS ELEMENTOS**/
 ID_COMUNES_EQUIPO_LINEAS_ACCION:  11, // para  lideres de lineas de acción // verificado-24
 ID_COMUNES_EQUIPO_PROYECTOS:  14,// verificado-24
 ID_COMUNES_RESPONSABLE:  10, // corresponde a los titulares del ambiente responsable // verificado-24
 ID_COMUNES_LIDER_PROYECTO:  15,// verificado-24
   ID_COMUNES_TIPO_PARTICIPANTE:  9,// verificado-24
   ID_COMUNES_EQUIPO_PLAN_ACCION:  12, // para lideres de planes de acción
   ID_COMUNES_EQUIPO_GERENCIAL:  13,
 USUARIO_ADMIN:  1,
 ID_COMUNES_PARTICIPANTE:  114,
 ID_FILTRO_ELEMENTO_PLAN: 'el',
  // Tabla Especial 1
 ID_ESPECIAL1_ENFOQUE:  1,// verificado-24
 ID_ESPECIAL1_PERSPECTIVA:  4, // verificado-24
 ID_ESPECIAL_UNO_ETAPA_PROYECTO:  9, // verificado-24
 ID_ESPECIAL_UNO_TIPO_PROCESO:  15,// verificado-24
 ID_ESPECIAL_DESEMPENIO_PROCESO:  18, // verificado-24
 ID_ESPECIAL_IMPORTANCIA_PROCESO:  24, // verificado-24
 ID_ESPECIAL_UNO_TIPO_INDICADOR:  30, // verificado-24
 ID_ESPECIAL_UNO_JERARQUIA:  34, // verificado-24


  // Tabla Especial 2
 ID_ESPECIAL_DOS_UNIDAD_DE_MEDIDA:  1, // verificado-24
 ID_ESPECIAL_DOS_AGRUPACION:  7,// verificado-24

  // Independientes
    //Maximos de PDF
  BIT_MAXIMO_PDF_CUMPLE_INDICADOR:  2000000, //Valor en Bites 
  FECHARESUMENEJECUTIVO:'12',
   
DIBUJAR: 5,

}
}